import ApiFactory from '@/api/ApiFactory';

// Define extended interfaces for custom methods
interface ExtendedUserService extends ReturnType<typeof ApiFactory.createQuery> {
  uploadProfilePicture: (options?: any) => ReturnType<ReturnType<typeof ApiFactory.createQuery>['post']>;
}

interface ExtendedLinkService extends ReturnType<typeof ApiFactory.createQuery> {
  uploadThumbnail: (linkId: string, options?: any) => ReturnType<ReturnType<typeof ApiFactory.createQuery>['post']>;
}

interface ExtendedProductService extends ReturnType<typeof ApiFactory.createQuery> {
  uploadThumbnail: (productId: string, options?: any) => ReturnType<ReturnType<typeof ApiFactory.createQuery>['post']>;
}

// API endpoints with /api/v1/ prefix - base URL should not include /api/v1
const LoginService = ApiFactory.createQuery({ url: '/api/v1/auth/login/', key: 'login_service' });
const VerifyOTPService = ApiFactory.createQuery({ url: '/api/v1/auth/login/verify-otp/', key: 'verify_otp_service' });
const UserService = ApiFactory.createQuery({
  url: '/api/v1/user/',
  key: 'user_service',
  authenticated: true,
}) as ExtendedUserService;

UserService.uploadProfilePicture = () => {
  return ApiFactory.createQuery({
    url: '/api/v1/user/upload-profile-picture/',
    key: 'upload_profile_picture',
    authenticated: true,
  }).post({});
};

const CheckUserTitleService = ApiFactory.createQuery({
  url: '/api/v1/user/check-title/',
  key: 'user_title_check_service',
  authenticated: true,
});

const MediaService = ApiFactory.createQuery({ url: '/api/v1/media/', key: 'media_service', authenticated: true });
const AuthenticatedLinkService = ApiFactory.createQuery({
  url: '/api/v1/link/',
  key: 'auth_link_service',
  authenticated: true,
});
const LinkService = ApiFactory.createQuery({
  url: '/api/v1/link/',
  key: 'link_service',
  authenticated: true,
}) as ExtendedLinkService;

LinkService.uploadThumbnail = (linkId: string) => {
  return ApiFactory.createQuery({
    url: `/api/v1/link/${linkId}/upload-thumbnail/`,
    key: 'upload_link_thumbnail',
    authenticated: true,
  }).post({});
};

const ProductService = ApiFactory.createQuery({
  url: '/api/v1/product/',
  key: 'product_service',
  authenticated: true,
}) as ExtendedProductService;

ProductService.uploadThumbnail = (productId: string) => {
  const query = ApiFactory.createQuery({
    url: `/api/v1/product/${productId}/upload-thumbnail/`,
    key: `upload_product_thumbnail_${productId}`,
    authenticated: true,
  });
  return query.post({});
};

export {
  LinkService,
  LoginService,
  VerifyOTPService,
  UserService,
  CheckUserTitleService,
  MediaService,
  AuthenticatedLinkService,
  ProductService,
};
